import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { Slide } from "@mui/material";
import a1 from "./a1.jpeg";
import a2 from "./a2.jpeg";
import a3 from "./a3.jpeg";
import a4 from "./a4.jpeg";
import a5 from "./a5.jpeg";
import a6 from "./a6.jpeg";
import a7 from "./a7.jpeg";
import a8 from "./a8.jpg";
import a9 from "./a9.jpg";
import a10 from "./a10.jpg";
import emailjs from "emailjs-com";
import { Form, Input, TextArea, Button } from "semantic-ui-react";
import Swal from "sweetalert2";
import { auth, getAuth, onAuthStateChanged } from "firebase/auth";

const SERVICE_ID = "dhproject1";
const TEMPLATE_ID = "template_inafc7l";
const PUBLIC_KEY = "GWhQ-YBtzZlmbESbK";

const Services = ({ language }) => {
  const handleClick = (e) => {
    e.preventDefault();
  };

  const [open, setOpen] = useState(false);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(SERVICE_ID, TEMPLATE_ID, e.target, PUBLIC_KEY, {
        name: e.target.name.value,
        email: e.target.email.value,
        message: e.target.message.value,
        phone: e.target.phone.value,
      })
      .then(
        (result) => {
          console.log(result.text);
          Swal.fire({
            icon: "success",
            title: "Message Sent Successfully",
          });
        },
        (error) => {
          console.log(error.text);
          Swal.fire({
            icon: "error",
            title: "Oops, something went wrong",
            text: error.text,
          });
        }
      );
    e.target.reset();
  };

  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe(); // Cleanup the listener when the component unmounts
  }, []);

  const handleClickOpen = () => {
    if (user) {
      setOpen(true);
    } else {
      setOpen(false);
      {language === 'en' && (
      alert("You need to LogIn first")
      )}
      {language === 'hi' && (
        alert("आपको पहले लॉगिन करने की आवश्यकता है।")
      )}
      console.log("Please login to continue");
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="border border-gray-100 shadow-sm relative my-2 items-center justify-center h-fit w-full flex flex-col">
        {language === "en" && (
          <p className="font-bold text-4xl text-center pt-16 pb-8">Services</p>
        )}
        {language === "hi" && (
          <p className="font-bold text-4xl text-center pt-16 pb-8">सेवाएं</p>
        )}
        <div className="flex justify-center items-center text-center pb-4">
          {/* <div className="grid grid-cols-2 gap-x-12 md:grid-cols-5">
          <div> Item 1 </div>
          <div> Item 1 </div>
          <div> Item 1 </div>
          <div> Item 1 </div>
          <div> Item 1 </div>
          <div> Item 1 </div>
          <div> Item 1 </div>
          <div> Item 1 </div>
          <div> Item 1 </div>
          <div> Item 1 </div>

          </div> */}
          <div className="grid grid-cols-2 md:gap-x-4 md:grid-cols-5 place-items-center items-center md:mx-8 md:px-20 ">
            <div
              onClick={handleClickOpen}
              className="flex flex-col space-y-2 items-center hover:shadow-xl my-3 pb-3 rounded-md sm:w-[100%] w-[100%] px-2 md:px-0 pt-4 h-[100%] bg-white hover:scale-110 transform ease-in-out hover:-translate-y-2 duration-1000"
            >
              <div className="align-top">
                <div>
                  <img
                    src={a1}
                    alt="test1"
                    className="flex flex-wrap justify-center rounded-xl pt-0 "
                  />
                </div>
                {language === "en" && (
                  <p className="font-bold pt-3 text-center">
                    3D Interior Designers
                  </p>
                )}
                {language === "hi" && (
                  <p className="font-bold pt-3 text-center">
                    3D इंटीरियर डिज़ाइनर
                  </p>
                )}
                {language === "en" && (
                  <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                    Being one of the leading organizations, we provide 3D
                    interior designing services our clients demands.
                  </p>
                )}
                {language === "hi" && (
                  <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                    हम अग्रणी संगठनों में से एक होने के नाते, हम अपने ग्राहकों
                    की मांग के अनुसार 3D इंटीरियर डिज़ाइनिंग सेवाएं प्रदान करते
                    हैं।
                  </p>
                )}
              </div>
              <div className="flex w-fit items-end h-full pb-2">
                {language === "en" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    Enquire Now
                  </button>
                )}
                {language === "hi" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    अभी पूछें
                  </button>
                )}
              </div>
            </div>
            <div
              onClick={handleClickOpen}
              className="flex flex-col space-y-2 items-center hover:shadow-xl my-3 pb-3 rounded-md sm:w-[100%] w-[100%] px-2 md:px-0 pt-4 h-[100%] hover:scale-110 transform ease-in-out hover:-translate-y-2 duration-1000"
            >
              <div className="align-top">
                <div>
                  <img
                    src={a2}
                    alt="test1"
                    className="flex flex-wrap justify-center rounded-xl pt-0 "
                  />
                </div>
                {language === "en" && (
                  <p className="font-bold pt-3 text-center">
                    Architects For Building
                  </p>
                )}
                {language === "hi" && (
                  <p className="font-bold pt-3 text-center">
                    आर्किटेक्ट्स फॉर बिल्डिंग
                  </p>
                )}
                {language === "en" && (
                  <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                    Get the consultation as well as render the responsibility to the best
                    Architects for designing stout and sturdy buildings.
                  </p>
                )}
                {language === "hi" && (
                  <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                    सलाह प्राप्त करें और मजबूत इमारतों के डिज़ाइन के लिए
                    सर्वश्रेष्ठ आर्किटेक्ट्स को जिम्मेदारी सौंपें।
                  </p>
                )}
              </div>
              <div className="flex w-fit items-end h-full pb-2">
                {language === "en" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    Enquire Now
                  </button>
                )}
                {language === "hi" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    अभी पूछें
                  </button>
                )}
              </div>
            </div>
            <div
              onClick={handleClickOpen}
              className="flex flex-col space-y-2 items-center hover:shadow-xl my-3 pb-3 rounded-md sm:w-[100%] w-[100%] px-2 md:px-0 pt-4 h-[100%] hover:scale-110 transform ease-in-out hover:-translate-y-2 duration-1000"
            >
              <div className="align-top">
                <div>
                  <img
                    src={a3}
                    alt="test1"
                    className="flex flex-wrap justify-center rounded-xl pt-0 "
                  />
                </div>
                {language == "en" && (
                  <p className="font-bold pt-3 text-center">
                    Architects For Office
                  </p>
                )}
                {language == "hi" && (
                  <p className="font-bold pt-3 text-center">
                    आर्किटेक्ट्स फॉर ऑफिस
                  </p>
                )}
                {language == "en" && (
                  <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                    Get your office designed in an innovative way, contact us for the best architecture and interior design for your office.
                  </p>
                )}
                {language == "hi" && (
                  <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                    अपनी कार्यालय को एक अद्वितीय ढंग से डिज़ाइन करें, अपने
                    कार्यालय के लिए सर्वश्रेष्ठ आर्किटेक्चर के लिए हमसे संपर्क
                    करें।
                  </p>
                )}
              </div>
              <div className="flex w-fit items-end h-full pb-2">
                {language === "en" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    Enquire Now
                  </button>
                )}
                {language === "hi" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    अभी पूछें
                  </button>
                )}
              </div>
            </div>
            <div
              onClick={handleClickOpen}
              className="flex flex-col space-y-2 items-center hover:shadow-xl my-3 pb-3 rounded-md sm:w-[100%] w-[100%] px-2 md:px-0 pt-4 h-[100%] hover:scale-105 transform ease-in-out hover:-translate-y-2 duration-1000"
            >
              <div className="align-top">
                <div>
                  <img
                    src={a4}
                    alt="test1"
                    className="flex flex-wrap justify-center rounded-xl pt-0 "
                  />
                </div>
                {language == "en" && (
                  <p className="font-bold pt-3 text-center">
                    Architects For Residential
                  </p>
                )}
                {language == "hi" && (
                  <p className="font-bold pt-3 text-center">
                    आर्किटेक्ट्स फॉर रेजिडेंशियल
                  </p>
                )}
                {language == "en" && (
                  <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                    Our company contains a set of architects that design excellent
                    residential spaces, giving it a beautiful touch.
                  </p>
                )}
                {language == "hi" && (
                  <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                    हमारी कंपनी में एक समूह आर्किटेक्ट्स हैं जो उत्कृष्ट आवासीय
                    स्थानों का डिज़ाइन करते हैं और उसे सुंदर स्पर्श देते हैं।
                  </p>
                )}
              </div>
              <div className="flex w-fit items-end h-full pb-2">
                {language === "en" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    Enquire Now
                  </button>
                )}
                {language === "hi" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    अभी पूछें
                  </button>
                )}
              </div>
            </div>
            <div
              onClick={handleClickOpen}
              className="flex flex-col space-y-2 items-center hover:shadow-xl my-3 pb-3 rounded-md sm:w-[100%] w-[100%] px-2 md:px-0 pt-4 h-[100%] hover:scale-105 transform ease-in-out duration-1000 hover:-translate-y-2"
            >
              <div className="align-top">
                <div>
                  <img
                    src={a5}
                    alt="test1"
                    className="flex flex-wrap justify-center rounded-xl pt-0 "
                  />
                </div>
                {language == "en" && (
                  <p className="font-bold pt-3 text-center">
                    Commercial Architects
                  </p>
                )}
                {language == "hi" && (
                  <p className="font-bold pt-3 text-center">
                    कमर्शियल आर्किटेक्ट्स
                  </p>
                )}
                {language == "en" && (
                  <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                    Get architects for designing as well as laying out the commercial
                    space be it business centers, factories, & much more.
                  </p>
                )}
                {language == "hi" && (
                  <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                    व्यापारिक स्थानों के डिज़ाइन और लेआउट के लिए आर्किटेक्ट्स
                    प्राप्त करें, चाहे व्यापार केंद्र, फैक्ट्री या बहुत कुछ हो।
                  </p>
                )}
              </div>
              <div className="flex w-fit items-end h-full pb-2">
                {language === "en" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    Enquire Now
                  </button>
                )}
                {language === "hi" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    अभी पूछें
                  </button>
                )}
              </div>
            </div>
            <div
              onClick={handleClickOpen}
              className="flex flex-col space-y-2 items-center hover:shadow-xl my-3 pb-3 rounded-md  sm:w-[100%] w-[100%] px-2 md:px-0 pt-4 h-[100%] hover:scale-105 transform ease-in-out hover:translate-y-2 duration-1000"
            >
              <div className="align-top">
                <div>
                  <img
                    src={a6}
                    alt="test1"
                    className="flex flex-wrap justify-center rounded-xl pt-0 "
                  />
                </div>
                {language === "en" && (
                  <p className="font-bold pt-3 text-center">
                    Interior Designers For Office
                  </p>
                )}
                {language === "hi" && (
                  <p className="font-bold pt-3 text-center">
                    इंटीरियर डिजाइनर्स फॉर ऑफिस
                  </p>
                )}
                {language === "en" && (
                  <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                    We provide various interior designing services for prestigious clients' offices. Contact us to know more.
                  </p>
                )}
                {language === "hi" && (
                  <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                    हम अपने प्रतिष्ठित ग्राहकों के लिए कार्यालयों के लिए
                    इंटीरियर डिजाइनिंग सेवाएं प्रदान करते हैं। और जानने के लिए
                    हमसे संपर्क करें।
                  </p>
                )}
              </div>
              <div className="flex w-fit items-end h-full pb-2">
                {language === "en" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    Enquire Now
                  </button>
                )}
                {language === "hi" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    अभी पूछें
                  </button>
                )}
              </div>
            </div>
            <div
              onClick={handleClickOpen}
              className="flex flex-col space-y-2 items-center hover:shadow-xl my-3 pb-3 rounded-md  sm:w-[100%] w-[100%] px-2 md:px-0 pt-4 h-[100%] hover:scale-105 transform ease-in-out hover:translate-y-2 duration-1000"
            >
              <div className="align-top">
                <div>
                  <img
                    src={a7}
                    alt="test1"
                    className="flex flex-wrap justify-center rounded-xl pt-0 "
                  />
                </div>
                {language === "en" && (
                  <p className="font-bold pt-3 text-center">
                    Residence Interior Designers
                  </p>
                )}
                {language === "hi" && (
                  <p className="font-bold pt-3 text-center">
                    रेज़िडेंस इंटीरियर डिज़ाइनर्स
                  </p>
                )}
                {language === "en" && (
                  <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                    We are professional interior designers who offer the best
                    designs for residence at an affordable price.
                  </p>
                )}
                {language === "hi" && (
                  <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                    हम पेशेवर इंटीरियर डिज़ाइनर्स हैं जो आपके आवास के लिए
                    सर्वोत्तम डिज़ाइन पेश करते हैं, और वह भी काफी सस्ते दामों
                    पर।
                  </p>
                )}
              </div>
              <div className="flex w-fit items-end h-full pb-2">
                {language === "en" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    Enquire Now
                  </button>
                )}
                {language === "hi" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    अभी पूछें
                  </button>
                )}
              </div>
            </div>
            <div
              onClick={handleClickOpen}
              className="flex flex-col space-y-2 items-center hover:shadow-xl my-3 pb-3 rounded-md sm:w-[100%] w-[100%] px-2 md:px-0 pt-4 h-[100%] hover:scale-105 transform ease-in-out hover:translate-y-2 duration-1000"
            >
              <div className="align-top">
                <div>
                  <img
                    src={a8}
                    alt="test1"
                    className="flex flex-wrap justify-center rounded-xl pt-0 "
                  />
                </div>
                {language === 'en' && (
                <p className="font-bold pt-3 text-center">Residential</p>
                )}
                {language === 'hi' && (
                <p className="font-bold pt-3 text-center">रेजिडेंशियल</p>
                )}
                {language === 'en' && (
                <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                  We provide you with a variety of several beautifully customised
                  residences on our very own website.
                </p>
                )}
                {language === 'hi' && (
                <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                  हम आपको हमारी अपनी वेबसाइट पर विभिन्न सुंदर रूपांतरित आवासों की विविधता प्रदान करते हैं।
                </p>
                )}
              </div>
              <div className="flex w-fit items-end h-full pb-2">
                {language === "en" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    Enquire Now
                  </button>
                )}
                {language === "hi" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    अभी पूछें
                  </button>
                )}
              </div>
            </div>
            <div
              onClick={handleClickOpen}
              className="flex flex-col space-y-2 items-center hover:shadow-xl my-3 pb-3 rounded-md sm:w-[100%] w-[100%] px-2 md:px-0 pt-4 h-[100%] hover:scale-105 transform ease-in-out hover:translate-y-2 duration-1000"
            >
              <div className="align-top">
                <div>
                  <img
                    src={a9}
                    alt="test1"
                    className="flex flex-wrap justify-center rounded-xl pt-0 "
                  />
                </div>
                {language === 'en' && (
                <p className="font-bold pt-3 text-center">Commercial</p>
                )}
                {language === 'hi' && (
                <p className="font-bold pt-3 text-center">कमर्शियल</p>
                )}
                {language === 'en' && (
                <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                  We add various elements of awe to your commercial or recreational
                  space without much ado.
                </p>
                )}
                {language === 'hi' && (
                <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                  हम आपके कमर्शियल या मनोरंजनिक स्थान में आश्चर्य के तत्व को जोश के साथ जोड़ते हैं, बिना बहुत बड़ी मेहनत के।
                </p>
                )}
              </div>
              <div className="flex w-fit items-end h-full pb-2">
                {language === "en" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    Enquire Now
                  </button>
                )}
                {language === "hi" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    अभी पूछें
                  </button>
                )}
              </div>
            </div>
            <div
              onClick={handleClickOpen}
              className="flex flex-col space-y-2 items-center hover:shadow-xl my-3 pb-3 rounded-md sm:w-[100%] w-[100%] px-2 md:px-0 pt-4 h-[100%] hover:scale-105 transform ease-in-out hover:translate-y-2 duration-1000"
            >
              <div className="align-top">
                <div>
                  <img
                    src={a10}
                    alt="test1"
                    className="flex flex-wrap justify-center rounded-xl pt-0 "
                  />
                </div>
                {language === 'en' && (
                <p className="font-bold pt-3 text-center">Retail</p>
                )}
                {language === 'hi' && (
                <p className="font-bold pt-3 text-center">रिटेल</p>
                )}
                {language === 'en' && (
                <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                  Whether it's a big shopping mall or small retail outlet, we do
                  it all in stipulated time period.
                </p>
                )}
                {language === 'hi' && (
                <p className="text-justify sm:w-[95%] lg:w-[95%] justify-center flex lg:pl-4 pt-2">
                  चाहे बड़ा शॉपिंग मॉल हो या छोटा रिटेल आउटलेट, हम सबकुछ समय सीमा में करते हैं।
                </p>
                )}
              </div>
              <div className="flex w-fit items-end h-full pb-2">
                {language === "en" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    Enquire Now
                  </button>
                )}
                {language === "hi" && (
                  <button
                    className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-200 sm:px-3 md:px-2 md:py-1 px-2 py-2"
                    type="submit"
                  >
                    अभी पूछें
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* form */}
      <div>
        <div onClick={handleClickOpen}>
          {/* <button
          className="rounded-3xl bg-orange-500 text-white text-sm lg:px-3 lg:py-2 hover:bg-orange-400 hover:scale-110 ease-in duration-100 sm:px-3 md:px-2 md:py-1 px-2 py-2"
          type="submit"
        >
          Enquire Now
        </button> */}
        </div>
        <Dialog
          open={open}
          onClose={handleClose}
          transitionDuration={700}
          TransitionComponent={Slide}
        >
          <div className="flex flex-row justify-between">
            <div className="pl-4"></div>
            <DialogTitle className="flex text-center">Send Enquiry</DialogTitle>
            <div className="pt-5 mr-4 scale-150 hover:opacity-70">
              <AiOutlineCloseCircle
                className="text-red-500"
                onClick={handleClose}
              />
            </div>
          </div>
          <DialogContent>
            <DialogContentText className="flex items-center justify-center">
              Write to us for any business enquiries
            </DialogContentText>
            <Form onSubmit={handleOnSubmit}>
              <Form.Field>
                <TextField
                  margin="dense"
                  id="name"
                  label="Enter Name"
                  type="text"
                  fullWidth
                  variant="outlined"
                  required={true}
                  name="from_name"
                />
              </Form.Field>
              <Form.Field>
                <TextField
                  margin="dense"
                  id="email"
                  label="Enter Email"
                  // type="tel"
                  fullWidth
                  variant="outlined"
                  required={true}
                  minLength={10}
                  maxLength={10}
                  // pattern="[0-9]{10}"
                  name="reply_to"
                />
              </Form.Field>
              <Form.Field>
                <TextField
                  margin="dense"
                  id="phone"
                  label="Enter Mobile"
                  type="tel"
                  fullWidth
                  variant="outlined"
                  required={true}
                  minLength={10}
                  maxLength={10}
                  pattern="[0-9]{10}"
                  name="mobile_no"
                />
              </Form.Field>
              <TextField
                margin="dense"
                id="message"
                label="Message"
                type="text"
                fullWidth
                variant="outlined"
                required={true}
                multiline={true}
                rows={4}
                maxLength={10}
                name="message"
              />
              <div className="flex justify-center mb-8 items-center mt-2">
                <button
                  onClick={handleClose}
                  className="rounded-3xl bg-orange-500 text-white md:px-64 px-10 sm:px-64 py-2 hover:bg-orange-400 hover:scale-105 ease-in duration-100"
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </Form>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default Services;
